import React from "react";
import TransactionsPage from "@/pages/TransactionsPage";

export default function Expenses() {
  return (
    <TransactionsPage
      kind="expense"
      title="Giderler"
      subtitle="Faturalar & Ödemeler"
      testidPrefix="expense"
    />
  );
}
